import {Component, OnInit} from '@angular/core';
import { ThemeConstantService } from '../../services/theme-constant.service';
import { AccountService } from '../../../core';
import { ADMIN_ROUTES, DEVELOPER_ROUTES, FEE_VIEWER_ROUTES, SUB_ADMIN_ROUTES } from './config-list-by-account';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Component({
    selector: 'app-sidenav',
    templateUrl: './side-nav.component.html',
    styleUrls: ["./side-nav.component.scss"],
})

export class SideNavComponent implements OnInit {
    public menuItems: any[];
    isFolded: boolean;
    isSideNavDark: boolean;
    url: string = 'link_route';
    selectedIndex : any = null;
    constructor( 
        private router: Router,
        private route: ActivatedRoute,
        private themeService: ThemeConstantService,
        private accountService: AccountService,
    ) {}

    ngOnInit(): void {
        const accountInfo = this.accountService.getInfo() || {};
        let routers = [];
        switch (accountInfo.adminGroup.code) {
            case 'ADMIN':
                routers = ADMIN_ROUTES;
            break;
            case 'SUB_ADMIN':
                routers = SUB_ADMIN_ROUTES;
            break;
            case 'F_VIEWER':
                routers = FEE_VIEWER_ROUTES;
            break;
            case 'DEVELOPER':
                routers = DEVELOPER_ROUTES;
            break;
            default:
                routers = ADMIN_ROUTES;
            break;
        }
        this.menuItems = routers.filter(menuItem => menuItem);
        this.themeService.isMenuFoldedChanges.subscribe(isFolded => this.isFolded = isFolded);
        this.themeService.isSideNavDarkChanges.subscribe(isDark => this.isSideNavDark = isDark);
        this.url = this.route.snapshot['_routerState'].url;
        this.router.events.subscribe( (event) => {
            if (event instanceof NavigationEnd) {
               this.url = event.url || '';
               this.checkUrl(this.url);
            }
        });
        this.checkUrl(this.route.snapshot['_routerState'].url);
    }
    checkUrl(url) {
        console.log('url', url);
        const split = (url || '').split('/');
        if (!split[0]) {
            split.shift();
        }
        const routes: any = {};
        split.forEach((route) => routes[route] = true);
        this.menuItems.forEach((menu) => {
            menu.selected = menu.path === '/' + split[0] || menu.path === split[0]; 
        })
    }
    test(index) {
        this.selectedIndex = this.selectedIndex !== index ? index : null;
    }
}
